export enum PartnerActionEnum {
  accept = 'accept',
  reject = 'reject',
  remove = 'remove',
}

export type PartnerAction = 'accept' | 'reject' | 'remove';
